import Input from '@/components/forms/Input';
import Select from '@/components/forms/Select';
import { Translation, useDynamicLocale } from '@/hoslog-intl';
import { useFormContext } from 'react-hook-form';
import { AffiliateFormValues } from '../affiliate-form.mapper';

type Props = {
  options: { label: string; value: string; labelEng?: string }[];
  isCorporation: boolean;
  selectedBusinessType?: string;
};

export const BusinessSection = ({ options, isCorporation, selectedBusinessType }: Props) => {
  const form = useFormContext<AffiliateFormValues>();
  const { t } = useDynamicLocale();

  return (
    <div className="grid w-full gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      <div className="lg:pl-12.5 text-primary font-bold">
        <Translation id="affiliate.page.affiliateInfoForm.businessInfo" />
      </div>
      <div className="grid grid-cols-2 col-span-2 gap-4">
        <div>
          <Select
            options={options}
            selected={selectedBusinessType}
            label="affiliate.page.affiliateInfoForm.businessType.label"
            forceRequired
            {...form.register('businessType')}
          />
        </div>
        {isCorporation && (
          <>
            <Input
              className="row-span-4"
              type="text"
              label="affiliate.page.affiliateInfoForm.ceoFullName.label"
              placeholder={t('manageStoreInformation.form.description.enterCeoFullname')}
              forceRequired
              {...form.register('ceoName')}
              maxLength={50}
            />
            <Input
              className="row-span-4"
              type="text"
              label="affiliate.page.affiliateInfoForm.ceoNameFurigana.label"
              placeholder={t('common.form.placeholder.furiganaPlaceholder')}
              forceRequired
              {...form.register('ceoNameFurigana')}
              maxLength={50}
            />
            <Input
              className="row-span-4"
              type="text"
              label="affiliate.page.affiliateInfoForm.companyName.label"
              placeholder={t('common.form.placeholder.companyName')}
              forceRequired
              {...form.register('companyName')}
              maxLength={50}
            />
            <Input
              className="row-span-4"
              type="text"
              label="affiliate.page.affiliateInfoForm.companyAddress.label"
              placeholder={t('manageStoreInformation.form.description.companyAddressPlaceholder')}
              {...form.register('companyAddress')}
              maxLength={50}
            />
          </>
        )}
      </div>
    </div>
  );
};
